import {
	Dialog,
	DialogBackdrop,
	Transition,
	TransitionChild,
} from "@headlessui/react";
import React, { FC, Fragment, useEffect, useRef, useState } from "react";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import ButtonClose from "shared/ButtonClose/ButtonClose";
import dayjs from "dayjs";

import "dayjs/locale/fr";
import { SelectHours } from "./SelectHours";
import { PlusIcon, XCircleIcon } from "@heroicons/react/24/solid";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import Select from "shared/Select/Select";
import { DAY_OFF_TYPES } from "contains/contants";
import Input from "shared/Input/Input";
import services from "utils/services";
dayjs.locale("fr");
export interface ModalUploadDocumentProps {
	show: boolean;
	employees: [];
	onConfirm: () => void;
	onCloseModal: () => void;
}

const ModalUploadDocument: FC<ModalUploadDocumentProps> = ({
	onConfirm,
	show,
	employees,
	onCloseModal,
}) => {
	const [files, setFiles] = useState<any>(
		employees
			.filter((emp: any) => emp.enabled)
			.sort((a: any, b: any) => parseInt(a.matricule) - parseInt(b.matricule))
			.map((emp: any) => {
				return { id: emp._id, ufile: null };
			})
	);

	const today = useRef(dayjs().startOf("month"));

	const [selectedMonth, setSelectedMonth] = useState<number | null>(null);
	const [selectedYear, setSelectedYear] = useState<number>(
		today.current.year()
	);

	const [yearList, setYearList] = useState<any>([]);
	const [monthList, setMonthList] = useState<any>([]);
	const [documentList, setDocumentList] = useState<any>([]);

	useEffect(() => {
		const monthList = [];
		const years = [];
		const currentDay = dayjs();

		for (let y = 2025; y <= currentDay.year(); y++) {
			years.push(y);
		}

		let firstMonth = currentDay.set("year", selectedYear).set("month", 0);

		const lastMonthNum =
			currentDay.year() == selectedYear
				? currentDay.date() > 15
					? currentDay.get("month")
					: currentDay.get("month") - 1
				: currentDay.get("month");
		setSelectedMonth(lastMonthNum);
		for (let m = 0; m <= lastMonthNum; m++) {
			monthList.push({
				value: firstMonth.get("month"),
				label: firstMonth.format("MMMM"),
			});
			firstMonth = firstMonth.add(1, "month");
		}

		setYearList(years);
		setMonthList(monthList);

		getDocuments();
	}, [selectedYear]);

	const getDocuments = () => {
		services.getDocuments(
			{ year: selectedYear, month: selectedMonth },
			(success) => {
				setDocumentList(
					success.documents.reduce((acc: any, doc: any) => {
						acc[doc.employee._id] = doc;
						return acc;
					}, {})
				);
			},
			(error) => {}
		);
	};

	useEffect(() => getDocuments(), [selectedMonth]);

	const onUpload = async () => {
		try {
			let formData = new FormData();
			// for (const p of files) {
			// let data: { orderId: string; product: any; photo: any } = {
			// 	orderId,
			// 	product: product.timestamp,
			// 	photo: null,
			// };
			// if (!p.ufile) {
			// 	// photos.forEach((p: any) => {
			// 	data.photo = {
			// 		filename: p.filename,
			// 		name: p.name,
			// 		typePhoto: p.typePhoto,
			// 	};
			// 	// });
			// } else {
			// Update the formData object
			// formData.append("orderId", orderId);
			// formData.append("product", product.timestamp);
			// formData.append("typePhoto", p.typePhoto);
			// formData.append("name", p.name);
			// formData.append("file", p.ufile);

			files.forEach((file: any, index: number) => {
				formData.append(`file_${file.id}`, file.ufile);

				// Métadonnées par employé
			});
			formData.append(`month`, selectedMonth + "");
			formData.append(`year`, selectedYear + "");
			// }

			// Details of the uploaded file
			// console.log(file);
			// }
			await services.uploadDocuments(
				formData,
				(success) => {
					if (success.ok) {
						onConfirm();
					}
					console.log(success);
				},
				(error) => {
					console.error(error);
				}
			);
			// }

			// onCloseModal();
		} catch (error) {
			console.error(error);
		}
	};

	return (
		<Transition appear show={show} as={Fragment}>
			<Dialog
				as="div"
				className="fixed inset-0 z-50"
				onClose={() => {
					onCloseModal();
				}}
			>
				<div className="flex items-stretch md:items-center justify-center h-full text-center md:px-4">
					<TransitionChild
						as={Fragment}
						enter="ease-out duration-300"
						enterFrom="opacity-0"
						enterTo="opacity-100"
						leave="ease-in duration-200"
						leaveFrom="opacity-100"
						leaveTo="opacity-0"
					>
						<DialogBackdrop className="fixed inset-0 bg-black/40 dark:bg-black/70" />
					</TransitionChild>

					{/* This element is to trick the browser into centering the modal contents. */}
					<span className="inline-block align-middle" aria-hidden="true">
						&#8203;
					</span>
					<TransitionChild
						as={Fragment}
						enter="ease-out duration-300"
						enterFrom="opacity-0 scale-95"
						enterTo="opacity-100 scale-100"
						leave="ease-in duration-200"
						leaveFrom="opacity-100 scale-100"
						leaveTo="opacity-0 scale-95"
					>
						<div className="relative inline-flex xl:py-8 xs:w-full max-h-full w-[600px]">
							<div
								className="flex-1 flex overflow-hidden max-h-full p-8 w-full text-left align-middle transition-all transform lg:rounded-2xl bg-white 
				  dark:bg-neutral-900 dark:border dark:border-slate-700 dark:text-slate-100 shadow-xl max-h-[500px]"
							>
								<span className="absolute right-3 top-3 z-50">
									<ButtonClose onClick={onCloseModal} />
								</span>

								<div className="flex-1 overflow-y-auto rounded-xl hiddenScrollbar text-center">
									<h3 className="text-xl font-semibold">Upload</h3>

									<div className="flex flex-row items-center justify-center mt-5 gap-3">
										<Select
											className="!w-[150px] rounded-lg border-slate-500 capitalize"
											onChange={({ target }) => {
												setSelectedMonth(parseInt(target.value));
											}}
											value={selectedMonth + ""}
										>
											{monthList.map((m: any, i: number) => (
												<option className="capitalize" value={m.value} key={i}>
													{m.label}
												</option>
											))}
										</Select>
										{yearList.length > 0 && (
											<Select
												className="!w-[100px] rounded-lg border-slate-500"
												onChange={({ target }) => {
													setSelectedYear(parseInt(target.value));
												}}
												value={selectedYear + ""}
											>
												{yearList.map((y: number, i: number) => {
													return (
														<option value={y} key={i}>
															{y}
														</option>
													);
												})}
											</Select>
										)}
									</div>
									<div className="flex flex-col items-center mt-5">
										{employees
											.filter((emp: any) => emp.enabled)
											.sort(
												(a: any, b: any) =>
													parseInt(a.matricule) - parseInt(b.matricule)
											)
											.map((emp: any, indexEmp: number) => {
												const fileName = files[indexEmp].ufile
													? files[indexEmp].ufile.name
													: documentList[emp._id]
													? documentList[emp._id].filename
													: "";
												return (
													<div
														className="flex flex-row fle items-center justify-between w-[100%] mb-1"
														key={indexEmp}
													>
														<div className="  flex-1">
															{emp.matricule} - {emp.firstName} {emp.lastName}
														</div>

														<div
															className={
																" flex-1 relative rounded-lg overflow-hidden flex flex-col items- justify-center  cursor-pointer "
															}
														>
															<ButtonSecondary
																fontSize={"text-[12px]"}
																className={` text-left bg-slate-200 cursor-pointer border !border-${
																	fileName ? "success" : "slate"
																} hover:border-slate-400 rounded-lg !py-2 !px-2 shadow-none w-[85%]`}
																onClick={() => {}}
															>
																{fileName
																	? fileName.length > 30
																		? fileName.substring(0, 30) + "..."
																		: fileName
																	: "Choisir un fichier"}
															</ButtonSecondary>

															<input
																type="file"
																className="absolute inset-0 opacity-0 cursor-pointer"
																name={`file_${emp._id}`}
																onChange={({ target }) => {
																	if (target.files && target.files.length > 0) {
																		files[indexEmp].ufile = target.files[0];
																		setFiles([...files]);
																	}
																}}
															/>
														</div>
													</div>
												);
											})}
									</div>

									<div className="flex flex-col sm:flex-row pt-6 items-center justify-center">
										<ButtonPrimary
											className="!py-2 !px-4 rounded-xl shadow-none"
											onClick={() => {
												// send();
												onUpload();
												// onConfirm(selectedYear, selectedMonth, files);
											}}
										>
											Valider
										</ButtonPrimary>
									</div>
								</div>
							</div>
						</div>
					</TransitionChild>
				</div>
			</Dialog>
		</Transition>
	);
};

export default ModalUploadDocument;
